import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { Colors } from "@/constants/Colors";
import { formatDate } from "@/utils/date";

interface SubscriptionInfoCardProps {
  plan: {
    active: boolean;
    currentPeriodEnd: string;
    paymentFailed?: boolean;
  };
  onContactSupport: () => void;
}

const SubscriptionInfoCard: React.FC<SubscriptionInfoCardProps> = ({
  plan,
  onContactSupport,
}) => {
  const renewalDate = plan.currentPeriodEnd
    ? formatDate(plan.currentPeriodEnd)
    : "N/A";

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Unlimited plan</Text>
        {plan.paymentFailed && (
          <View style={styles.failedBadge}>
            <Text style={styles.failedBadgeText}>Failed payment</Text>
          </View>
        )}
      </View>

      <View style={styles.card}>
        <Text style={styles.text}>
          Your current subscription is{" "}
          <Text style={styles.bold}>$7 per month. </Text>
          Billed at $84 per year and will renew on{" "}
          <Text style={styles.bold}>{renewalDate}.</Text>
        </Text>
      </View>

      <TouchableOpacity onPress={onContactSupport}>
        <Text style={styles.supportLink}>Still need help? Contact support</Text>
      </TouchableOpacity>
    </View>
  );
};

export default SubscriptionInfoCard;

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
  header: {
    flexDirection: "column",
    gap: 4,
    marginBottom: 16,
  },
  title: {
    fontSize: 17,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#161D14",
  },
  failedBadge: {
    alignSelf: "flex-start",
    backgroundColor: "#FDE7D1",
    borderWidth: 1,
    borderColor: "#C12915",
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  failedBadgeText: {
    fontSize: 13,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#C12915",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
  },
  text: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#161D14",
    lineHeight: 21,
  },
  bold: {
    fontFamily: FontFamilies.Inter.Bold,
  },
  supportLink: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: Colors.primary,
  },
});
